/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
// import core & vendor packages below
import { Row, Col, Form, Button, FormControl, InputGroup } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// import components below
import FormUI from 'components/UI/FormUI';
import { ReactComponent as MagnifyingGlassSVG } from 'assets/svg/magnifying_glass.svg';
import { getPatient } from 'reducers/patientReducer';

// import assets below
import './Filter.scss';

// main component
const ClearanceFilter = ({ data, filter, setFilter, setFilteredData }) => {
  const dispatch = useDispatch();

  /* const [filter, setFilter] = useState({
    patient_name: '',
    bed_category: '',
    status: '',
  }); */

  const handleChange = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.target.value,
    });
  };

  const handleSubmit = () => {
    // dispatch(getPatient(filter));
    const newFilteredData = data.filter(
      (patient) =>
        patient?.full_name.toLowerCase().startsWith(filter.patient_name.toLowerCase()) &&
        // patient?.physician_name?.toLowerCase().includes(filter.physician_name.toLowerCase()) &&
        (!filter?.status ? patient?.patient_status : patient?.patient_status === filter?.status),
    );
    setFilteredData(newFilteredData);
  };

  useEffect(() => {
    dispatch(getPatient());
  }, []);

  return (
    <div className='clearanceFilter mb-4'>
      <FormUI>
        <Row className='d-flex align-items-end'>
          <Col>
            <Form.Group className='mb-3'>
              <Form.Label>Patient Name</Form.Label>
              <InputGroup>
                <InputGroup.Text className='bg-white'>
                  <MagnifyingGlassSVG />
                </InputGroup.Text>
                <FormControl
                  type='search'
                  className='bg-white'
                  placeholder='Search here...'
                  value={filter.patient_name}
                  onChange={handleChange('patient_name')}
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-3'>
              <Form.Label>Bed Category</Form.Label>
              <Form.Select onChange={handleChange('bed_category')}>
                <option value=''>- Select -</option>
                <option value='private'>Private</option>
                <option value='suite'>Suite</option>
                <option value='ward'>Ward</option>
                <option value='operating_room'>Operating Room</option>
                <option value='delivery_room'>Delivery Room</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className='mb-3'>
              <Form.Label>Status</Form.Label>
              <Form.Select onChange={handleChange('status')}>
                <option value=''>- Select -</option>
                <option value='for_discharge'>For Discharge</option>
                <option value='emergency'>Emergency</option>
                <option value='admitted'>Admitted</option>
                <option value='discharged'>Discharged</option>
                <option value='for_admission'>For Admission</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col>
            <div className='buttonWrapper mb-3'>
              <Button variant='search' onClick={() => handleSubmit()}>
                Apply
              </Button>
            </div>
          </Col>
        </Row>
      </FormUI>
    </div>
  );
};

export default ClearanceFilter;
